import { useTranslator } from '@othercommerce/foundation';

interface Options {
  realizationFrom: number | null;
  realizationTo: number | null;
}

export function useRealizationTime({ realizationFrom: min, realizationTo: max }: Options) {
  const translator = useTranslator();

  if (min && max && (min !== max)) {
    return translator.choice('SHOP.COMMON.LABEL.MIN_MAX_REALIZATION_TIME', max, { min, max });
  }

  if (max) {
    return translator.choice('SHOP.COMMON.LABEL.MAX_REALIZATION_TIME', max, { max });
  }

  return null;
}
